import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { handleGateError } from './guards.tsx';

/**
 * `staleTime` 30 s e `refetchOnWindowFocus` (`spec/17-frontend.md` §4.5): o refetch no
 * foco é o fallback obrigatório enquanto o SSE não estiver conectado, não um enfeite.
 */
export function createQueryClient(): QueryClient {
  const client: QueryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: false,
      },
    },
    queryCache: new QueryCache({
      onError: (error) => {
        handleGateError(error, client);
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        handleGateError(error, client);
      },
    }),
  });
  return client;
}

/** Singleton do app. Testes montam o seu com `createQueryClient()`. */
export const queryClient = createQueryClient();
